module.exports = __webpack_public_path__ + "static/media/Start Screeen-07.56118bc4.webp";